import {ErrorsRanked} from '../errors/ErrorsRanked'
import {ModeSettingEnum} from '../GameEnums'
import {GameModeDataController} from '@colonist/shared-types'
import {UserItems} from '../store/UserItems'

export function userHasAccessToRankedCitiesAndKnights(userItems: UserItems | undefined): boolean {
    if(userItems == undefined) return false
    const citiesAndKnightsData = GameModeDataController.getModeDataForMode(ModeSettingEnum.CitiesAndKnights4P)
    if(citiesAndKnightsData == undefined) throw new ErrorsRanked.ServerErrorCitiesAndKnights()

    if(userItems.membership != undefined) return true
    if(userItems.hasAccessToPremiumMode(citiesAndKnightsData)) return true

    return false
}
